import React from 'react';

const ArrowRight = () => (
  <svg
    className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 transition-colors"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
  </svg>
);

const SectionTitle = React.memo(({ icon, title, badge, onViewAll }) => (
  <div className="flex items-center justify-between mb-3">
    <h3 className="flex items-center gap-2 text-[15px] font-bold text-gray-900">
      {icon && <span className="text-lg leading-none" aria-hidden>{icon}</span>}
      <span>{title}</span>
      {badge && (
        <span className="ml-1 text-[10px] font-semibold uppercase tracking-wide bg-emerald-100 text-emerald-700 rounded-full px-2 py-0.5">
          {badge}
        </span>
      )}
    </h3>
    <button
      type="button"
      onClick={onViewAll}
      className="group p-1 -mr-1 rounded-full hover:bg-gray-100 transition-colors"
      aria-label={`View all ${title}`}
    >
      <ArrowRight />
    </button>
  </div>
));

SectionTitle.displayName = 'SectionTitle';

export default SectionTitle;
